import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import useAsyncEffect from "@n1ru4l/use-async-effect";

import BasePersonalDataForm from "../base-personal-data-form";
import StayDataForm from "../stay-data-form";
import ConfirmButton from "../confirm-button";
import ExperienceDataForm from "../experience-data-form";
import Summary from "../price/summary";
import LargeDivisor from "../large-divisor";
import Notes from "../notes";
import Confirmation from "../confirmation";
import ChooseRoom from "../choose-room";
import { getExperience } from "../../model/experience";
import {
  sendMail,
  setSelectedExperiences,
  setReservationType,
  startup
} from "../../store/actions";
import {
  DateType,
  GuestsType,
  pick,
  numSelectedExperiencesGuestsPropType
} from "../../model/utils";
import Title from "../titles/title";
import ConfirmationHeader from "../titles/confirmation-header";
import { experiencePropType } from "../../model/utils";
import ChooseTable from "../choose-table";
import TableDataForm from "../table-data-form";

const mapDispatchToProps = dispatch => ({
  setSelectedExperiences: value => dispatch(setSelectedExperiences(value)),
  sendMail: sendMailOptions => dispatch(sendMail(sendMailOptions)),
  sendType: () => dispatch(setReservationType("experience")),
  start: () => dispatch(startup())
});

const ReserveExperienceForm = props => {
  const {
    status,
    selectedExperiences,
    setSelectedExperiences,
    hasRoomKind,
    hasTable,
    experienceReservationValid,
    sendType,
    start
  } = props;

  useAsyncEffect(
    function*() {
      setSelectedExperiences([yield getExperience()]);
    },
    [setSelectedExperiences]
  );

  React.useEffect(() => {
    start();
    sendType();
  }, [sendType, start]);

  const onConfirm = () => props.sendMail(props);

  return (
    <div style={{ color: "#171717", width: "100%", lineHeight: "28px" }}>
      {status === "input" ? (
        <>
          <Title stringKey="experienceTitle" />
          <BasePersonalDataForm />
          {(selectedExperiences || []).length > 0 && (
            <ExperienceDataForm
              large={true}
              experience={selectedExperiences[0]}
            />
          )}
          <ChooseTable withNote />
          {hasTable && <TableDataForm />}
          <ChooseRoom />
          {hasRoomKind && <StayDataForm />}
          <LargeDivisor />
          <Summary />
          <LargeDivisor />
          <Notes />
          <ConfirmButton
            disabled={!experienceReservationValid}
            onClick={onConfirm}
          />
        </>
      ) : status === "sending" ? (
        <div>Sending...</div>
      ) : (
        <>
          <ConfirmationHeader />
          <Title stringKey="confirmationTitle" />
          <Confirmation />
        </>
      )}
    </div>
  );
};

ReserveExperienceForm.propTypes = {
  selectedExperiences: PropTypes.arrayOf(experiencePropType),
  setSelectedExperiences: PropTypes.func,
  hasRoomKind: PropTypes.bool,
  hasTable: PropTypes.bool,
  experienceReservationValid: PropTypes.bool,
  name: PropTypes.string,
  surname: PropTypes.string,
  country: PropTypes.string,
  postcode: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  numRoomGuests: GuestsType,
  roomKind: PropTypes.object,
  hasExperience: PropTypes.bool,
  numSelectedExperiencesGuests: numSelectedExperiencesGuestsPropType,
  roomDates: DateType,
  notes: PropTypes.string,
  status: PropTypes.string,
  sendMail: PropTypes.func,
  sendType: PropTypes.func,
  start: PropTypes.func.isRequired,
  roomPrice: PropTypes.number,
  experiencePrice: PropTypes.number
};

export default connect(
  pick([
    "country",
    "dateRanges",
    "numNights",
    "email",
    "experiencePrice",
    "experienceReservationValid",
    "experiencesDates",
    "experiencesPrices",
    "experiencesTimes",
    "focusedField",
    "hasExperience",
    "hasRoomKind",
    "hasTable",
    "name",
    "notes",
    "numRoomGuests",
    "numSelectedExperiencesGuests",
    "phoneNumber",
    "postcode",
    "reservationType",
    "roomDates",
    "roomKind",
    "roomPrice",
    "roomReservationValid",
    "selectedExperiences",
    "status",
    "surname",
    "numTableGuests",
    "tableDate",
    "tableTime"
  ]),
  mapDispatchToProps
)(ReserveExperienceForm);
